import { createAction } from "redux-act";

export const setUser = createAction("Set user");
export const clearUser = createAction("Clear user");
export const setToken = createAction("Set token");
export const logout = createAction("Log out");